module.exports = __webpack_public_path__ + "static/media/menu_alta_modulo.8c15c9a6.svg";